<template>
  <h2 class="header">{{ $t('cv.interests') }}</h2>
  <section class="container">
    <div class="grid-layout">
      <div
        :class="`item-${i + 1}`"
        class="item"
        v-for="(int, i) in interests"
        :key="i"
      >
        <img :src="require('@/assets/interests/' + int.image + '.jpg')" />
        <div class="text">
          <div class="name">{{ int.name }}</div>
          <div class="desc">{{ int.description }}</div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

// Importujemy dane dla obu języków
import interestsPl from '@/data/pl/interests'
import interestsEn from '@/data/en/interests'
import interestsDe from '@/data/de/interests'
import interestsEs from '@/data/es/interests'
import interestsRu from '@/data/ru/interests'
import interestsJp from '@/data/jp/interests'

// Zdefiniuj interfejs zgodnie z tym, co masz w pliku (np. name, icon, description)
// Jeśli Twoje interests to po prostu tablica tekstów, możesz pominąć ten interfejs
// i w mapie użyć Record<string, string[]>
interface Interest {
  name: string
  // dodaj pozostałe pola, jeśli istnieją
  [key: string]: any
}

// Tworzymy mapę (słownik) języków
const interestsMap: Record<string, Interest[]> = {
  pl: interestsPl,
  en: interestsEn,
  de: interestsDe,
  es: interestsEs,
  ru: interestsRu,
  jp: interestsJp,
}

export default defineComponent({
  computed: {
    // Computed automatycznie reaguje na zmiany $i18n.locale
    interests(): Interest[] {
      const locale = this.$i18n.locale as string

      // Zwracamy odpowiednią tablicę (z angielskim jako awaryjnym fallbackiem)
      return interestsMap[locale] || interestsMap['en']
    },
  },
})
</script>

<style scoped lang="scss">
.grid-layout {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(4, 1fr);

  gap: 0.75rem;
  max-width: 1000px;
  margin: auto;
  min-height: 450px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    min-height: auto;
    gap: 0.5rem;
  }
}

.item {
  // background-color: $rose;
  overflow: hidden;
  border-radius: 0.5rem;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
    transform: translate3d(0, 0, 1px);

    top: 0;
    left: 0;
    opacity: 1;
    transition: transform 0.3s ease-in-out;
  }
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.025);
    img {
      opacity: 0;
    }
    .text {
      transform: scaleX(1);
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;
    min-height: 120px;
  }
}

.text {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: $light;
  height: 100%;
  width: 100%;
  padding: 15px;

  top: 0;
  left: 0;
  user-select: none;

  transition: all 0.3s ease-in-out;
  transform: scaleX(0);
  .name {
    font-size: 15px;
    font-weight: 500;
    color: $dark;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  .desc {
    font-size: 12px;
  }
}

.item-1 {
  grid-column: 1 / 4;
  grid-row: 1;

  .text {
    transform-origin: left;
  }

  @media (max-width: 768px) {
    grid-column: 1 / 2;
    grid-row: auto;
  }
}
.item-2 {
  grid-column: 4 / 6;
  grid-row: 1;
  .text {
    transform-origin: right;
  }

  @media (max-width: 768px) {
    grid-column: 2 / 3;
    grid-row: auto;
  }
}
.item-3 {
  grid-column: 6 / 8;
  grid-row: 1 / 4;
  .text {
    transform-origin: left;
  }

  @media (max-width: 768px) {
    grid-column: 1 / 3;
    grid-row: auto;
  }
}

.item-4 {
  grid-column: 1 / 3;
  grid-row: 2 / 4;
  .text {
    transform-origin: left;
  }

  @media (max-width: 768px) {
    grid-column: 1 / 2;
    grid-row: auto;
  }
}
.item-5 {
  grid-column: 3 / 6;
  grid-row: 2 / 4;
  .text {
    transform-origin: right;
  }

  @media (max-width: 768px) {
    grid-column: 2 / 3;
    grid-row: auto;
  }
}

.item-6 {
  grid-column: 1 / 4;
  grid-row: 4 / 5;
  .text {
    transform-origin: left;
  }

  @media (max-width: 768px) {
    grid-column: 1 / 2;
    grid-row: auto;
  }
}

.item-7 {
  grid-column: 4 / 8;
  grid-row: 4;
  .text {
    transform-origin: left;
  }

  @media (max-width: 768px) {
    grid-column: 2 / 3;
    grid-row: auto;
  }
}
</style>
